import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from '@/app/App.tsx'
// Imported for its side effect: catches the browser's install prompt early.
import '@/pwa/installPrompt.ts'
import { registerTenantServiceWorker } from '@/pwa/register.ts'
import { initBasePath } from '@/tenant/basePath.ts'
import '@/styles/global.css'

// Resolved before the first render: every in-app link is built from it, and
// a studio prefix that arrived late would produce links to the wrong tenant.
initBasePath(window.location.pathname)

const rootElement = document.getElementById('root')

if (rootElement === null) {
  throw new Error('Root element #root is missing from index.html')
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Registered after the first paint: an unavailable worker must never delay
// or block the app from booting.
void registerTenantServiceWorker()
